import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useOnclickOutside from 'react-cool-onclickoutside';
import styles from './style.module.scss';
import { ReactComponent as ArrowIcon } from '../../assets/ArrowIcon.svg';

interface FeatureItem {
    title: string;
    description: string;
    path: string;
    icon?: React.ComponentType<any>;
}

const getFeaturesData = (t: any): FeatureItem[] => [
    {
        title: t('featuresDropdown.shadowChat.title'),
        description: t('featuresDropdown.shadowChat.description'),
        path: '/generation/shadow-chat'
    },
    {
        title: t('featuresDropdown.photoSolver.title'),
        description: t('featuresDropdown.photoSolver.description'),
        path: '/generation/ai-photo-solver'
    },
    {
        title: t('featuresDropdown.summarizer.title'),
        description: t('featuresDropdown.summarizer.description'),
        path: '/summarizer'
    },
    {
        title: t('featuresDropdown.paragraphGenerator.title'),
        description: t('featuresDropdown.paragraphGenerator.description'),
        path: '/paragraph-generator'
    },
    {
        title: t('featuresDropdown.abstractGenerator.title'),
        description: t('featuresDropdown.abstractGenerator.description'),
        path: '/abstract-generator'
    }
];

export const FeaturesDropdown: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const featuresData = getFeaturesData(t);
    
    const ref = useOnclickOutside(() => {
        setIsOpen(false);
    });

    const handleFeatureClick = (path: string) => {
        navigate(path);
        setIsOpen(false);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={styles.dropdown} ref={ref}>
            <button 
                className={styles.dropdownTrigger}
                onClick={toggleDropdown}
            >
                <span>{t('featuresDropdown.title')}</span>
            </button>
            
            <div className={`${styles.dropdownContainer} ${isOpen ? styles.dropdownContainerOpen : ''}`}>
                <div className={styles.dropdownContent}>
                    {featuresData.map((feature, index) => (
                        <div
                            key={index}
                            className={styles.featureItem}
                            onClick={() => handleFeatureClick(feature.path)}
                        >
                            <div className={styles.featureTitle}>
                                {feature.title}
                            </div>
                            <div className={styles.featureDescription}>
                                {feature.description}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};